import React from 'react'
import cx from 'classnames'
import MuiTableCell from '@material-ui/core/TableCell'

export default ({ children, cxNames, ...props }) => (
  <MuiTableCell {...props} className={cx(cxNames)} classes={{ root: 'lh-title' }}>
    {children}
  </MuiTableCell>
)
